// images @ ui/src/components/static/
// files @ ui/public/

import React, { Component } from 'react'
import './home.css'

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const images = importAll(require.context('./static', false));
//console.log('images:', images)


class HomeEN extends Component {
  constructor(props) {
    super(props)
    this.topFunction = this.topFunction.bind(this);
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  render() {
    //console.log('images: ', images)
    return (
      <section className="mx-5" style={{ maxWidth: "100%" }} >
        <p id="FSV Usage" className="title is-6"><span style={{fontSize: "24px", color: 'red'}}>FiveStar Vocab<sup>TM</sup>:</span> The Smartest Way to Activate Your Vocabulary</p>
        <p style={{ color: 'blue' }}> FiveStar Vocab 与 SpellingBee (SB) 是旨在激活您词汇量的功能互补型工具 。FiveStar Vocab 通过建立图像与单词之间的联系来增强阅读理解能力，而 SB 则专注于听力理解 。</p>
        <br></br>

        <p><b>1. FiveStar Vocab [1] </b>是一种用于掌握英语词汇的方法(国家发明专利正在处理中) 。为了实现深层次的理解，每个单词都被拆解为五个核心组成部分 。这为非英语母语（ESL）的学习者和初学者提供了一条“最小阻力”的学习路径 。</p>
        <img src={images['five-star-word-w-5com.png']} width="285" height="196" alt="five-star-figure" 
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        <br></br>

        <p id="FSV ref" className="title is-6">2: 核心科学原理：为什么它行之有效</p> 
        <p>1) 人类大脑拥有三个记忆区域</p>
        <p><b>瞬时记忆（Sensory Memory）:</b> 用于初步接触信息 。</p>
        <p><b>工作记忆（Working Memory）:</b> 用于主动排演和编码 。</p>
        <p><b>长期记忆（Long-Term Memory）:</b> 存储主动、持久的知识 。</p>
        <img src={images['3-vocab-mem-areas.png']} alt="3-vocab-mem-areas" />
        <p>注意： 长期记忆并非永久性的 。如果您长期不使用，或者只是孤立地、死记硬背单词，您的大脑最终会将其清除，以便为更重要的事情腾出空间 。</p>
        <br></br>

        <p>2) 轻松学习 vs. 合意困难学习（Desirable Difficulties）[4] </p>
        <p>不同于“轻松学习”（如海量刷题）这种最初感觉高效但无法建立持久知识的方式，FiveStar Vocab 利用了“合意困难”（DDs）原理 。虽然合意困难在起步阶段可能让人感觉更费力，但它们能带来更卓越的长期表现和永久性的记忆保留 。</p>
        <br></br>

        <p>3) 合意困难学习与简单学习的演示 (source: 长沙一家人--捡瓶子比赛)</p>
        <video width="263" height="394" controls >
        <source src="./videos/bottle-collect-demo-1min.mp4" type="video/mp4"/>
        </video>
        <br></br> <br></br>

        <p id="FSV ref" className="title is-6">3. The Scaffolded Serial Books and Customized Services</p> 
        <p>The "Scaffolded" serial books are specifically designed for ESL students and beginners to master English vocabulary by using the FiveStar Vocab style.</p>
        <p>Attached is a demo vocabulary handbook:
          <a href="The-Scaffolded-English-Vocabulary-Handbook(demo).pdf" target="_blank" rel="noopener noreferrer"> <u>The-Scaffolded-English-Vocabulary-Handbook(demo).pdf</u>
          </a>        
        </p><br></br>

        <p>To check the publish and upcoming books, please check our bookstore: </p>
        <a href="/bookstore" target="_blank"><u>Bookstore updated info</u></a>
        <br></br> <br></br>

        <p><b>Customized Services and Contacts</b></p>
        <p>If you have a specialized vocabulary list or any another language you wish to adapt into the FiveStar Vocab
        style book, or you need like to order the upcoming books, please click bottom "Email Contact", and we are happy to help you.</p>
        <br></br>

        <p id="FSV ref" className="title is-6">4. Key references</p> 
        <p>[1] 
          <a href="./FiveStar Vocab: The Smartest Way to Activate Your Vocabulary.pdf" target="_blank" rel="noopener noreferrer"> <u>FiveStar Vocab: The Smartest Way to Activate Your Vocabulary</u>
          </a>
        </p>
        <p>[2] Lev Vygotsky, Zone of Proximal Development (ZPD) and Scaffolding, 1930s</p>
        <p>[3] Nation, I. S. P., Learning Vocabulary in Another Language, Cambridge University Press, 2013</p>
        <p>[4] Bjork, E. L., & Bjork, R. A., Introducing desirable difficulties into practice and instruction: Obstacles and opportunities, 2023
        </p>
        <br></br>

      </section>
    )
  }
}

export default HomeEN